import { crossOriginRequestJson } from '../lib/flexeApi';
import { ReasonCode, SubmitScopeForApprovalRequest, ScopeReviewer } from './data/ReservationScopeInterfaces';

export class ReservationScopeService {
  public async retrieveScopeReasonCodes(): Promise<ReasonCode[]> {
    const response = await crossOriginRequestJson('GET', `/api/v2/admin/reservation-scopes/reason-codes`);
    const responseBody = await response.json();

    const { data, error } = responseBody;

    if (data) {
      return data.reasonCodes as ReasonCode[];
    } else if (error && typeof error !== 'string') {
      throw new Error(error.msg);
    }
  }

  public async retrieveScheduledEndReasonCodes(): Promise<string[]> {
    const response = await crossOriginRequestJson(
      'GET',
      `/api/v2/admin/reservation-scopes/scheduled-end-date-reason-codes`,
    );
    const responseBody = await response.json();

    const { data, error } = responseBody;

    if (data) {
      return data.scheduledEndDateReasonCodes as string[];
    } else if (error && typeof error !== 'string') {
      throw new Error(error.msg);
    }
  }

  public async getAllowedScopeReviewers(): Promise<ScopeReviewer[]> {
    const response = await crossOriginRequestJson('GET', `/api/v1/admin/reservation_scopes/allowed_scope_approvers`);
    const responseBody = await response.json();

    const { data, error, errors } = responseBody;

    if (error) {
      throw new Error(typeof error === 'string' ? error : error.msg);
    }

    if (errors && errors.length > 0) {
      throw new Error(errors[0].title);
    }

    return (data || responseBody) as ScopeReviewer[];
  }

  public async submitScopeForApproval(request: SubmitScopeForApprovalRequest): Promise<void> {
    const response = await crossOriginRequestJson(
      'PUT',
      `/api/v1/admin/reservation_scopes/${request.scopeId}/submit_for_approval`,
      {
        scope_approval_policy: request.scopeApprovalPolicy,
        scope_manager_approval_email: request.scopeManagerApprovalEmail,
        reservation_scope_change_reason_code_id: request.scopeReasonCodeId,
      },
    );
    const responseBody = await response.json();

    const { error } = responseBody;

    if (error) {
      throw new Error(error.msg);
    }
    return;
  }

  public async cancelScope(scopeId: number): Promise<void> {
    const response = await crossOriginRequestJson('PUT', `/api/v1/admin/reservation_scopes/${scopeId}/cancel`, {});
    const responseBody = await response.json();

    const { errors } = responseBody;

    if (errors && errors.length > 0) {
      throw new Error(errors[0].title);
    }
    return;
  }
}

export default ReservationScopeService;
